<template>
	<div class="more">
		<van-action-sheet v-model:show="visible" z-index="1000">
			<div class="more-wrap">
				<div class="top-bar" />
				<div class="btn-wrap">
					<div class="operate-item">
						<img src="@/assets/img/more/days.png" alt="" />
						<span>日程</span>
					</div>
					<div class="operate-item">
						<img src="@/assets/img/more/avtive.png" alt="" />
						<span>活动</span>
					</div>
					<div @click="toPage('/layout/information', { type: 3 })" class="operate-item">
						<img src="@/assets/img/more/news.png" alt="" />
						<span>资讯</span>
					</div>
					<div @click="toPage('/layout/center', {})" class="operate-item">
						<img src="@/assets/img/more/my.png" alt="" />
						<span>我的</span>
					</div>
				</div>
			</div>
		</van-action-sheet>
	</div>
</template>
<script setup lang="ts">
const visible = ref(false)
const router = useRouter()
const show = () => {
	visible.value = true
}

const toPage = (path, query) => {
	router.push({ path, query })
	visible.value = false
}

defineExpose({ show })
</script>
<style scoped lang="scss">
.more {
	.more-wrap {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 5px 20px;
		box-sizing: border-box;
		.top-bar {
			width: 40px;
			height: 4px;
			background: #d9d9d9;
			border-radius: 24px;
		}
		.btn-wrap {
			width: 100%;
			display: flex;
			align-items: center;
			margin: 50px 0 100px 0;
			justify-content: space-between;
			.operate-item {
				display: flex;
				flex-direction: column;
				align-items: center;
				> img {
					margin-bottom: 8px;
					width: 40px;
					height: 40px;
				}
				> span {
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #424649;
					line-height: 16px;
					text-align: left;
					font-style: normal;
					text-transform: none;
				}
			}
		}
	}
}
</style>
